import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { AgGridModule } from 'ag-grid-angular';
import { WalletRoutingModule } from './wallet-routing.module';
import { WalletComponent } from './wallet.component';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CreidtlinereportComponent } from './creidtlinereport/creidtlinereport.component';
import { AddFundsComponent } from './add-funds/add-funds.component';
import { ManageRetailerFundsComponent } from './manage-retailer-funds/manage-retailer-funds.component';
import { ManageAdminFundsComponent } from './manage-admin-funds/manage-admin-funds.component';


@NgModule({
  declarations: [WalletComponent, CreidtlinereportComponent, AddFundsComponent, ManageRetailerFundsComponent, ManageAdminFundsComponent],
  imports: [
    WalletRoutingModule,
    MatButtonToggleModule,
    FeaturesCommonModule,
    AgGridModule
  ],
  exports: [WalletComponent, CreidtlinereportComponent, AddFundsComponent, ManageRetailerFundsComponent,],
 
})
export class WalletModule { }
